import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import enResource from './messages/en.json'
import deResource from './messages/de.json'

const resources1 = {
  en: { translation: enResource },
  de: { translation: deResource }
}

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    lng: 'en',
    fallbackLng: 'en',
    resources: resources1,
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  })

const language = window.localStorage.getItem('language')
if (language) {
  i18n.changeLanguage(language)
}

export default i18n
